import React from 'react';
import cx from 'classnames';
import greycatLogo from '../../assets/images/greycat-head.svg';
import tsIcon from '../../assets/images/ts-icon.svg';
import styles from './language-icon.module.scss';
export default ({ language, className }) => {
    switch (language) {
        case 'typescript':
            return (React.createElement("span", { className: cx(styles.languageIcon, styles.typescript, className), dangerouslySetInnerHTML: { __html: tsIcon } }));
        case 'greycat':
            return (React.createElement("span", { className: cx(styles.languageIcon, styles.greycat, className), dangerouslySetInnerHTML: { __html: greycatLogo } }));
    }
};
